import React, { useEffect, useState } from 'react'
import { Wrapper } from './style'
import { ConfigProvider, message, Pagination, Table } from 'antd';
import { Link, useSearchParams } from 'react-router-dom';
import {Helmet} from "react-helmet";
import ImportManager from './lib/importManager';
import ExportManager from './lib/exportManager'
import { MakeApiCall } from '../../../apis';

function UploadManager({userData}) {
  const [searchParams, setSearchParams] = useSearchParams();

  // Default to import if tab is not present in URL
  const tabFromUrl = searchParams.get("tab") || "import";
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  const [totalPage, setTotalPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  
  const [importList, setImportList] = useState([]);
  const [exportList, setExportList] = useState([]);

  // Add state for summary counts
  const [importCount, setImportCount] = useState(0);
  const [exportCount, setExportCount] = useState(0);

  // Add state for filter data
  const [filterData, setFilterData] = useState({
    import: {
      statuses: [],
      types: [],
      sources: []
    },
    export: {
      statuses: [],
      types: []
    }
  });

  // Fetch filter data
  const fetchFilterData = async () => {
    try {
      const response = await MakeApiCall(
        'data-logs/filter-data',
        'get',
        null,
        true,
        {},
        userData?.token
      );
      if (response?.status && response?.data) {
        setFilterData({
          import: {
            statuses: response.data.import?.statuses || [],
            types: response.data.import?.types || [],
            sources: response.data.import?.sources || []
          },
          export: {
            statuses: response.data.export?.statuses || [],
            types: response.data.export?.types || []
          }
        });
      }
    } catch (error) {
      console.error('Error fetching filter data:', error);
    }
  };

  // Fetch summary counts
  const fetchSummaryCounts = async () => {
    try {
      const response = await MakeApiCall(
        'data-logs/summary',
        'get',
        null,
        true,
        {},
        userData?.token
      );
      if (response?.status && response?.data) {
        setImportCount(response.data.imports_total ?? 0);
        setExportCount(response.data.exports_total ?? 0);
      } else {
        setImportCount(0);
        setExportCount(0);
      }
    } catch (error) {
      setImportCount(0);
      setExportCount(0);
    }
  };

  useEffect(() => {
    fetchSummaryCounts();
    fetchFilterData();
  }, [userData]);

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    setSearchParams({ tab: tabKey });
  };

  return (
      <Wrapper>
        <Helmet><title>File Manager</title></Helmet>
        <div className="mb-10 mx-md-n9 mx-n2 px-10 py-5 bg-white filter">
          <div className="position-relative ">
            <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 d-inline-flex">
              <li className="nav-item">
                <Link
                    className={`nav-link ${activeTab === 'import' ? 'active' : ''}`}
                    onClick={() => handleTabChange('import')}
                >
                  <i className="bi bi-upload me-3 fs-4 text-gray-900"></i>
                  Import <span className="text-danger fs-5 ms-3">{importCount}</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                    className={`nav-link ${activeTab === 'export' ? 'active' : ''}`}
                    onClick={() => handleTabChange('export')}
                >
                  <i className="bi bi-download me-3 fs-4 text-gray-900"></i>
                  Export <span className="text-danger fs-5 ms-3">{exportCount}</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {activeTab === 'import' && (
          <ImportManager 
            list={importList} 
            loading={loading} 
            userData={userData}
            filterData={filterData.import}
          />
        )}
        {activeTab === 'export' && (
          <ExportManager 
            list={exportList} 
            loading={loading} 
            userData={userData}
            filterData={filterData.export}
          />
        )}
      </Wrapper>
  )
}

export default UploadManager